import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Inspector } from './inspector';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { baseUrl, gatewayFile, baseAPI } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class InspectorService {

  private url = baseUrl + gatewayFile;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getInspectorList(): Observable<Inspector[]> {
    const url = `${this.url}`;
    return this.http.post<Inspector[]>(url, { token: localStorage.getItem('token'), function: 'getInspectorList' })
    .pipe(
      catchError(this.handleError('getInspectorList', []))
    );
  }

  updateInspectorEmailAndPhone(email: String, phone: String, inspectorId: String) {
    const url = baseAPI + '/insync/updatePhoneNumberAndEmail';
    return this.http.put<any>(url, {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      email,
      phone,
      inspectorId,
    })
    .pipe(
      catchError(this.handleError('updateInspectorEmailAndPhone'))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return throwError(error);
    };
  }
}
